var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCgrLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "130px",
  height: "130px",
  viewBox: "0 0 130 130",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "a",
  cx: 44.8809524,
  cy: 44.8809524,
  r: 44.8809524
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m79.89 78.929 13.286 13.287c3.578-2.201 8.325-1.752 11.426 1.349l20.792 20.792a9.286 9.286 0 1 1-13.132 13.132L91.47 106.697c-3.019-3.02-3.525-7.6-1.517-11.141L76.607 82.212l3.283-3.283Z",
  fill: "#003865"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#003865",
  cx: 49.5238095,
  cy: 49.5238095,
  r: 49.5238095
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 49.5238095,
  cy: 49.5238095,
  r: 47.202381
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.642857, 4.642857)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#003865",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.551.773h-4.794l.003.017c1.233 9.069 9.422 17.999 21.222 22.76l.395.157.81.315C54.355 28.026 61.79 35.44 63.055 42.704l.044.272c.127.696.191 1.322.191 1.88 0 .559-.078 1.284-.233 2.188-1.257 7.196-8.526 14.508-18.488 18.543l-.384.154-.8.31-.402.16C31.307 70.922 23.176 79.71 21.804 88.662l-.047.326h4.794l.029-.164c1.356-7.21 8.377-14.331 18.122-18.285l.386-.154.806-.313.4-.16c12.18-4.909 20.645-14.187 21.606-23.318.061-.652.091-1.223.091-1.713s-.03-1.062-.09-1.705c-.963-9.147-9.435-18.42-21.603-23.326l-.398-.159-.816-.316C35.13 15.45 27.944 8.229 26.577.92l-.026-.147Z",
  fill: "#F0AB00",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.969 17.02c4.08 4.2 9.472 7.788 15.806 10.278l.825.32c3.895 1.534 7.271 3.584 9.942 5.869.329.281 10.737-7 10.106-7.615-4.069-3.972-9.328-7.374-15.43-9.771l-.83-.322c-3.843-1.515-7.153-3.537-9.765-5.803-.752-.653-11.246 6.433-10.654 7.043Z",
  fill: "#003865",
  mask: "url(#b)",
  transform: "translate(45.310049, 21.714076) scale(-1, 1) translate(-45.310049, -21.714076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.969 63.352c4.08 4.202 9.472 7.789 15.806 10.279l.825.32c3.895 1.534 7.271 3.584 9.942 5.869.329.281 10.737-7 10.106-7.615-4.069-3.972-9.328-7.374-15.43-9.771l-.83-.322c-3.843-1.515-7.153-3.537-9.765-5.803-.752-.653-11.246 6.433-10.654 7.043Z",
  fill: "#003865",
  mask: "url(#b)",
  transform: "translate(45.310049, 68.047056) scale(-1, -1) translate(-45.310049, -68.047056)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.107.773H67.9l-.003.017c-1.233 9.069-9.423 17.999-21.222 22.76l-.395.157-.811.315C35.304 28.026 27.868 35.44 26.604 42.704l-.045.272c-.126.696-.19 1.322-.19 1.88 0 .559.078 1.284.233 2.188 1.257 7.196 8.525 14.508 18.487 18.543l.385.154.8.31.402.16C58.35 70.922 66.482 79.71 67.854 88.662l.047.326h-4.794l-.03-.164c-1.355-7.21-8.376-14.331-18.121-18.285l-.386-.154-.806-.313-.4-.16c-12.18-4.909-20.645-14.187-21.607-23.318-.06-.652-.09-1.223-.09-1.713s.03-1.062.09-1.705c.963-9.147 9.435-18.42 21.603-23.326l.398-.159.816-.316C54.527 15.45 61.714 8.229 63.08.92l.026-.147Z",
  fill: "#F0AB00",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.071 80.09a2.321 2.321 0 0 1 .137 4.638l-.137.004h-12.38a2.321 2.321 0 0 1-.137-4.639l.136-.004h12.381ZM48.75 53.005a2.321 2.321 0 0 1 .136 4.639l-.136.004h-7.738a2.321 2.321 0 0 1-.136-4.64l.136-.003h7.738Zm0-19.345a2.321 2.321 0 0 1 .136 4.639l-.136.004h-7.738a2.321 2.321 0 0 1-.136-4.64l.136-.003h7.738ZM51.071 5.03a2.321 2.321 0 0 1 .137 4.639l-.137.004h-12.38a2.321 2.321 0 0 1-.137-4.64l.136-.003h12.381Z",
  fill: "#F0AB00",
  mask: "url(#b)"
})))));

export default SvgCgrLogo;